import { async } from "@firebase/util";
import axios from "axios";
import { deleteDoc, doc, getDoc, getFirestore, onSnapshot, setDoc } from "firebase/firestore";
import {getFunctions,httpsCallable} from "firebase/functions";
import { useEffect, useState } from "react";
import { CloseButton, Table } from "react-bootstrap";
import { AiFillCodeSandboxCircle } from "react-icons/ai";
import { CgClose, CgCross, CgTapDouble } from "react-icons/cg";
import { FaPen } from "react-icons/fa";
import swal from "sweetalert";
import EventBookingDetails from "./eventBookingDetails";
import MessageDetails from "./messageDetails";
import VideoDetails from "./videoDetails";


export default function RequestDetails(props){

    const db=getFirestore();
    const [currentOrderDetails,setcurrentOrderDetails]= useState({});
    const [userData,setUserData]=useState({});
    const [celebData,setCelebData]=useState({});
    const [userId,setUserId]=useState("");
    const [celebId,setCelebId]=useState("");
    var orderId=props.id;
 
    useEffect(async()=>{


        const unsubscribe= onSnapshot(doc(db,"requests",props.id),async(doca)=>{
            var data= doca.data();
            setcurrentOrderDetails(data);

            getDoc(doc(db,"users",data["user"].toString())).then((doca2)=>{
                setUserData(doca2.data());
                setUserId(doca2.id);
            });

            getDoc(doc(db,"celebrities",data["celebrity"].toString())).then((doca3)=>{
                setCelebData(doca3.data());
                setCelebId(doca3.id);
            });

        })

        return function(){
            unsubscribe();
        }

    },[]);



    return (
        <div className="flex flex-row z-10  overflow-scroll absolute backdrop-blur-sm w-full">
            <div className="w-2/4 bg-transparent relative"></div>

            <div className="p-10 w-2/4 bg-black/90 flex justify-start items-start h-full relative flex-col overflow-scroll">


                <div className="self-end">
                    <button
                        onClick={()=>{
                            props.closeButton()
                        }}
                    >
                        <CgClose size={50}/>
                    </button>
                </div>

                <div className="text-6xl font-bold mt-2">
                        Request Details
                </div>



                <div className="w-full flex flex-row justify-evenly items-center gap-4 mb-10 mt-10">

                        <div className="h-72 w-full bg-red-500 flex flex-col">
                            <div style={{backgroundImage:`url('${userData["imgSrc"]}')`}}
                            className="w-full h-64 bg-contain bg-center bg-no-repeat bg-white rounded-md"/>
                            <div className="h-10 p-2 flex w-full text-ellipsis overflow-hidden">
                                {userData["fullName"]}
                            </div>
                        </div>

                        <div className="h-72 w-full bg-red-500 flex flex-col">
                            <div style={{backgroundImage:`url('${celebData["imgSrc"]}')`}}
                            className="w-full h-64 bg-contain bg-center bg-no-repeat bg-white rounded-md"/>
                            <div className="h-10 p-2 flex w-full text-ellipsis overflow-hidden">
                                {celebData["fullName"]}
                            </div>
                        </div>

                </div>



                {currentOrderDetails["type"]=="dm"?<MessageDetails userId={userId} celebId={celebId} data={currentOrderDetails} userData={userData} celebData={celebData}   />:""}
                {currentOrderDetails["type"]=="videoRequest"?<VideoDetails userId={userId} celebId={celebId} data={currentOrderDetails} userData={userData} celebData={celebData}   />:""}
                {currentOrderDetails["type"]=="eventBooking"?<EventBookingDetails userId={userId} celebId={celebId} data={currentOrderDetails} userData={userData} celebData={celebData}   />:""}

                {currentOrderDetails["status"]=="complete"?
                <button 
                onClick={async()=>{
                    await setDoc(doc(db,"requests",props.id),{"status":"refunded"},{merge:true});
                    var userWallet=userData["wallet"];
                    await setDoc(doc(db,"users",userId),{"wallet":(userWallet+currentOrderDetails["amount"])},{merge:true});
                    var celebWallet=celebData["wallet"];
                    if( (celebWallet-currentOrderDetails["amount"])<0){
                        await setDoc(doc(db,"celebrities",celebId),{"wallet":0},{merge:true});
                    }
                    else{
                        await setDoc(doc(db,"celebrities",celebId),{"wallet":(celebWallet-currentOrderDetails["amount"])},{merge:true});
                    }
                    
                }}
                className="hover:scale-105 p-2 bg-red-500 rounded-md font-bold text-xl w-2/4 self-center mt-5 flex justify-center items-center">
                     Refund
                </button>:""}


                {/* <button 
                onClick={async()=>{
                    var userWallet=userData["wallet"];

                    if(currentOrderDetails["status"]=="refunded"){
                        // await setDoc(doc(db,"users",userId),{"wallet":(userWallet+currentOrderDetails["amount"])},{merge:true});
                        await props.closeButton();
                        await deleteDoc(doc(db,"requests",props.id));
                    }
                    else if(currentOrderDetails["status"]=="pending"){
                        // await setDoc(doc(db,"users",userId),{"wallet":(userWallet+currentOrderDetails["amount"])},{merge:true});
                        await props.closeButton();
                        await deleteDoc(doc(db,"requests",props.id));
                    }
                    else if(currentOrderDetails["status"]=="complete"){
                        await setDoc(doc(db,"users",userId),{"wallet":(userWallet+currentOrderDetails["amount"])},{merge:true});
                        await props.closeButton();
                        await deleteDoc(doc(db,"requests",props.id));
                    }
                    else if(currentOrderDetails["status"]=="rejected"){
                        await props.closeButton();
                        await deleteDoc(doc(db,"requests",props.id));
                    }
                    
                }}
                className="hover:scale-105 p-2 bg-red-500 rounded-md font-bold text-xl w-2/4 self-center mt-4 flex justify-center items-center">
                     Delete
                </button> */}
                
                

            </div>

        </div>
    )
    
}